export interface ITask {
	client_id?: number;
	custom_value1?: string;
	custom_value2?: string;
	description?: string;
	project_id?: number;
	time_log?: string;
}
